import type { ReactNode } from "react";
import { cx } from "../cx";
import styles from "./PageHeader.module.css";

export interface PageHeaderProps {
  title: ReactNode;
  /**
   * `page` = legacy h2 page title (18px/500 `#333`, "Time Tracker", "Projects");
   * `profile` = 24px/400 `#666` h1 of My profile / Preferences.
   */
  variant?: "page" | "profile";
  actions?: ReactNode;
  /** Content between title and actions (e.g. a report-type switcher). */
  children?: ReactNode;
  className?: string;
}

export function PageHeader({ title, variant = "page", actions, children, className }: PageHeaderProps) {
  return (
    <header className={cx(styles.header, styles[variant], className)}>
      <h1 className={styles.title}>{title}</h1>
      {children && <div className={styles.middle}>{children}</div>}
      {actions && <div className={styles.actions}>{actions}</div>}
    </header>
  );
}
